<template>
  <div class="row">
    <div class="col-12">
      <div class="row bg-light-grey mx-0 upgrades-box">
        <div class="col-xl-9">
          <ul class="nav nav-tabs d-md-flex" role="tablist">
            <li class="nav-item flex-sm-fill text-center" v-for="(headline,index) in upgrades">
              <a data-toggle="tab" :href="'#tab'+index" role="tab" :class="{ 'active': index == 0 }">{{ headline.name}}</a>
            </li>
          </ul>
          <div class="tab-content overflow-hidden">
            <div class="tab-pane  overflow-hidden" role="tabpanel" v-for="(content,index) in upgrades" :class="{ 'active': index == 0 }" :id="'tab'+index">
              <div v-for="(group,index) in content.group.groups" class="m-pane">
                <div class="h3 mt-3">{{ group.name }}</div>
                <ul class="list-unstyled single-upgrade">
                  <li class="d-flex mt-4 position-relative" v-for="item in group.items" @click="addToGroup(item,group.select,content.group.select,content)" :class="{ 'active': item.active }">
                    <div>{{ item.data.texts.name3 }}</div>
                    <div class="flex-fill">{{ item.data.texts.name1 }}</div>
                    <a :href="'/'+item.data.texts.urlPath+'/a-'+item.data.item.id">Details</a>
                    <div>{{ item.data.prices.default.unitPrice.formatted }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="upgrades">
            <div class="heading">
              {{ $translate("Servershop5::Template.upgradeAuswahl") }}
            </div>
            <ul class="list-unstyled mb-0">
              <li class="font-weight-bold">
                {{ iteminfo.texts.name1 }}
              </li>
              <li v-for="section in current">
                <p v-html="section.name"></p>
                <ul class="list-unstyled">
                  <li v-for="items in section.items" class="font-weight-bold">
                    {{ items.data.texts.name1 }}
                  </li>
                </ul>
              </li>
              <li>
                <p>{{ $translate("Servershop5::Template.pricewithupdates") }}</p>
                <ul class="list-unstyled">
                  <li>
                    <div class="font-weight-bold upgadePrice">{{ upgradesPrice | currency }}</div>
                    <span class="upgradeVat">
                                           <!--  * {% if services.customer.showNetPrices() %}}{{ $translate("Ceres::Template.singleItemExclVAT") }}{% else %}}{{ $translate("Ceres::Template.singleItemInclVAT") }}{% endif %}} {{ $translate("Ceres::Template.singleItemExclusive") }}
                                           <a href="{{ Link(ceresConfig.global.shippingCostsCategoryId) }}" title="{{ $translate("Ceres::Template.singleItemShippingCosts") }}">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>-->
                                        </span>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="heading">
              <label class="d-flex align-items-center">
                <span class="flex-fill d-none d-lg-flex"> {{ $translate("Servershop5::Template.menge") }}</span>
                <div class="d-flex qty-wrapper">
                  <button class="qty-btn minus" @click="changeQuantity('minus')">-</button>
                  <input type="number" v-model="quantity" class="flex-fill" @change="changeQuantityInput()">
                  <button class="qty-btn plus" @click="changeQuantity('plus')">+</button>
                </div>
              </label>
              <button class="btn btn-primary btn-block mt-3 pa-0 row" style="font-size:0.9rem" @click="intoBasket()">
                                <span class="mr-2">
                                  <i class="icon-cart-1 p"></i>
                                </span>
                <span >
                                       {{ $translate("Servershop5::Template.toBasketWithUpgrade") }}
                                </span>
              </button>
              <!--                              <template v-if="onlyOnRequest" background-color: #fff3cd;
    color: #856404 !important;>
                                <a :href="'/kontakt/?productID='+iteminfo.id+'&productName='+iteminfo.texts.name1" class="d-block " target="_blank"><i class="icon-ticket mr-1"></i>{{ $translate("Servershop5::Template.zumticket") }}</a>

                              </template>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default
{
  props:
      {
        item:
            {
              type: Object,
              default: null
            }
      },

  data: function()
  {
    return {
      iteminfo:this.item,
      configuration: [],
      current: [],
      quantity:1
    };
  },
  mounted: function()
  {
    var _self = this;
    this.$nextTick(function ()
    {
      this.getFiles();
    })
  },
  methods:
      {
        getFiles: function()
        {
          var _self = this;
          var MainItem = this.iteminfo;

          if(MainItem.hasOwnProperty('variationProperties'))
          {
            for (var i = 0; i < MainItem.variationProperties.length; i++) {
              if (MainItem.variationProperties[i].id === 3) {
                for (var a = 0; a < MainItem.variationProperties[i].properties.length; a++) {
                  if (MainItem.variationProperties[i].properties[a].id !== 10) {
                    if (MainItem.variationProperties[i].properties[a].id === 9) {
                      let position = MainItem.variationProperties[i].properties[a].position;
                      $.ajax(
                          {
                            type: 'GET',
                            url: 'https://www.servershop24.de/'+App.language+'/upgrades/get/' + MainItem.variationProperties[i].properties[a].values.value + '/' + App.language,
                            dataType: 'json',
                            success: function (data) {
                              data.position = position;
                              vueEventHub.$emit("garantie-item", data);
                              //store2.commit('add',data);
                              _self.configuration.unshift(data);
                              _self.current.unshift(
                                  {
                                    "name": data.name,
                                    "select": data.group.select,
                                    "items": [],
                                    "position": position
                                  }
                              )
                              _self.$store.commit("setUpgrades", data);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                              console.error(errorThrown);
                            }
                          });
                    } else {
                      let position = MainItem.variationProperties[i].properties[a].position;
                      $.ajax(
                          {
                            type: 'GET',
                            url: 'https://www.servershop24.de/'+App.language+'/upgrades/get/' + MainItem.variationProperties[i].properties[a].values.value + '/' + App.language,
                            dataType: 'json',
                            success: function (data) {
                              data.position = position;
                              _self.configuration.unshift(data);
                              _self.current.unshift(
                                  {
                                    "name": data.name,
                                    "select": data.group.select,
                                    "items": [],
                                    "position": position
                                  }
                              )
                              _self.$store.commit("setUpgrades", data);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                              console.error(errorThrown);
                            }
                          });
                    }
                    _self.configuration.sort(function (a, b) {
                      return a[0].position - b[0].position;
                    });
                  }
                }
              }
            }
          }

        },
        resetActiveItems: function(items)
        {
          var _self = this;


          for( let i = 0; i < items.length; i++)
          {
            items[i].active = false;
          }
        },
        resetAllActiveItems: function()
        {
          var _self = this;

          for( let i = 0; i < _self.configuration.length; i++)
          {
            for (let a = 0; a < _self.configuration[i].group.groups.length; a++)
            {
              for (let b = 0; b < _self.configuration[i].group.groups[a].items.length; b++)
              {
                _self.configuration[i].group.groups[a].items[b].active = false;
              }
            }
          }
        },
        intoBasket:function()
        {
          var _self = this;
          var items = [];
          var quantity = this.quantity;
          items.push(
              {
                "variationId":this.iteminfo.variation.id,
                "quantity":quantity
              }
          );
          for( let i = 0; i < _self.current.length; i++)
          {
            for( let a = 0; a < _self.current[i].items.length; a++)
            {
              var item =
                  {
                    "variationId": _self.current[i].items[a].id,
                    "quantity": quantity
                  }
              items.push(item);
            }
          }
          var data =
              {
                "items": items
              }
          $.ajax({
            type: 'POST',
            url: 'https://www.servershop24.de/'+App.language+'/upgrades/add/',
            data: data,
            success: function (data)
            {
              for( var i = 0; i < data.length; i++)
              {
                if(data[i].error)
                {
                  CeresNotification.success(_self.$translate("Ceres::Template.singleItemAdded")).closeAfter(3000);
                }
                else
                {
                  CeresNotification.success(_self.$translate("Ceres::Template.singleItemAdded")).closeAfter(3000);
                }
                if(i===data.length-1)
                {
                  vueApp.$store.commit("setBasketItems", data[i].basketItems);
                  vueApp.$store.commit("setBasket", data[i].basket);
                }
              }
              // _self.waiting = false;
              for( let i = 0; i < _self.current.length; i++)
              {
                _self.current[i].items = [];
                _self.resetAllActiveItems();
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
            }
          })
          this.quantity = 1;

        },
        changeQuantityInput: function()
        {
          var min = this.iteminfo.variation.minimumOrderQuantity;
          var max = this.iteminfo.stock.net;
          if(this.quantity < min)
          {
            this.quantity = min;
          }
          if(this.quantity > max)
          {
            this.quantity = max;
          }

        },
        changeQuantity: function(change)
        {
          var min = this.iteminfo.variation.minimumOrderQuantity;
          var max = this.iteminfo.stock.net;
          if(change === 'plus')
          {
            if(this.quantity < max)
            {
              this.quantity = this.quantity+1;
            }
          }
          else
          {
            if(this.quantity > min)
            {
              this.quantity = this.quantity - 1;
            }
          }
        },
        updatePrice: function()
        {
          let self = this;
          let price = 0;
          for(let i =0; i<self.current.length; i++)
          {
            for(let o = 0; o<self.current[i].items.length;o++)
            {
              price = price+self.current[i].items[o].data.prices.default.unitPrice.value
            }
          }
          price = price+this.iteminfo.prices.default.unitPrice.value;
          return price;
        },
        addToGroup: function(item,groupSelect,parentGroupSelect,upgrades) {
          var _self = this;

          for (let i = 0; i < _self.current.length; i++) {
            if (upgrades.name === _self.current[i].name) {
              if (parentGroupSelect === "single") {
                if (groupSelect === 'multiselect') {
                  // gruppe aus der die derzeit aktive id stammt
                  var currentGroup = '';
                  // ids der vorhadenen items
                  var groupArrayIds = [];

                  // items
                  var thisGroupItems = _self.current[i].items;


                  for (var a = 0; a < _self.current[i].items.length; a++) {
                    groupArrayIds.push(_self.current[i].items[a].data.item.id)
                  }


                  // finde die gruppe in der die id vorhanden ist
                  for (var b = 0; b < upgrades.group.groups.length; b++) {
                    var itemsArray = [];
                    for (var d = 0; d < upgrades.group.groups[b].items.length; d++) {
                      itemsArray.push(upgrades.group.groups[b].items[d].data.item.id);
                    }
                    // daten sind schon angereichert / IDS müssen vorher seperiert werden
                    if (itemsArray.indexOf(groupArrayIds[0]) > -1) {
                      currentGroup = itemsArray;
                    }
                  }

                  if (currentGroup.indexOf(item.data.item.id) > -1) {
                    /* Testblock*/
                    if (_self.current[i].items.length > 0) {
                      var dublicate = false;
                      for (let z = 0; z < _self.current[i].items.length; z++) {
                        if (_self.current[i].items[z].id === item.id) {
                          dublicate = true
                        }
                      }

                      if (dublicate === false) {
                        item.active = true;
                        _self.current[i].items.push(item);
                      }
                    } else {
                      item.active = true;
                      _self.current[i].items.push(item);
                    }
                    /* Testblock*/
                  } else {
                    _self.resetActiveItems(_self.current[i].items);
                    _self.current[i].items = [];
                  }
                } else {
                  _self.resetActiveItems(_self.current[i].items);
                  _self.current[i].items = [];
                }


                if (_self.current[i].items.length > 0) {
                  var dublicate = false;
                  for (let z = 0; z < _self.current[i].items.length; z++) {
                    if (_self.current[i].items[z].id === item.id) {
                      dublicate = true
                    }
                  }

                  if (dublicate === false) {
                    item.active = true;
                    _self.current[i].items.push(item);
                  }
                } else {
                  item.active = true;
                  _self.current[i].items.push(item);
                }
              } else {
                if (_self.current[i].items.length > 0) {
                  var dublicate = false;
                  for (let z = 0; z < _self.current[i].items.length; z++) {
                    if (_self.current[i].items[z].id === item.id) {
                      dublicate = true
                    }
                  }

                  if (dublicate === false) {
                    item.active = true;
                    _self.current[i].items.push(item);
                  }
                } else {
                  item.active = true;
                  _self.current[i].items.push(item);
                }
              }
            }
          }
        }
      },
  computed:
      {
        /*onlyOnRequest: function()
        {
          let tags = this.iteminfo.tags;

          for(let i = 0;i < tags.length ; i++)
          {
            if(tags[i].id == 202)
            {
              return true
            }
          }
          return false;
        },*/
        upgrades: function()
        {
          return this.configuration;
        },
        garantie: function ()
        {
          var config = this.configuration;
          for( let i = 0; i < config.length; i++)
          {
            if(config[i].propId===9)
            {
              return config[i];
            }
          }
        },
        upgradesPrice: function ()
        {
          let self = this
          return self.updatePrice()
        }
      }
}
</script>
